import CloseButton from 'app/components/Header/CloseButton';

import DefaultCta from './DefaultCta';
import NbrCta from './NbrCta';
import { type TailorCtaButtonProps } from './types';

const TailorCta = ({
  messages,
  suggestedArticle,
  showSuggestedArticle,
  isExpanded,
  onClick,
  onClickCloseChatBubble,
  unreadMessageCount,
}: TailorCtaButtonProps) => {
  return (
    <div className="widget-position-mobile md:widget-position-desktop pointer-events-auto shadow-lg rounded-[6px] text-[14px]">
      {suggestedArticle && showSuggestedArticle && isExpanded ? (
        <NbrCta
          suggestedArticle={suggestedArticle}
          onClick={onClick}
        />
      ) : (
        <DefaultCta
          messages={messages}
          isExpanded={isExpanded}
          onClick={onClick}
          unreadMessageCount={unreadMessageCount}
        />
      )}

      {isExpanded && (
        <CloseButton
          id="ostro-webchat-close-text-button"
          onClick={onClickCloseChatBubble}
          circleClassName="bg-white w-6 h-6 shadow-lg"
          className="absolute top-[-10px] left-[-10px] w-6 h-6"
          useCustomIcon
          closeIconClassName="text-black fill-black"
        />
      )}
    </div>
  );
};

export default TailorCta;
